module.exports = __webpack_public_path__ + "static/media/landing-health-management-phone.93f9d073.png";